import { IItem } from '../../typings/searchResults'
import { toTitle } from '../utils/formatString'
import ga from '../utils/ga'
import { getCurrentSiteDomain } from '../utils/sites'

const getListName = (pageType: string): string => {
  if (pageType === 'category') {
    return 'Search Results: Category'
  }

  return 'Search Results: Search'
}

export const reportProductClick = (
  index: number,
  item: IItem,
  currentSite: string,
  pageType: string
) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  ga('ec:addProduct', {
    brand: item.author_username,
    category: `${currentSiteDomain}/${item.classification}`,
    id: item.id,
    list: getListName(pageType),
    name: item.name,
    position: index
  })
  ga('ec:setAction', 'click', {
    list: getListName(pageType)
  })
  ga('send', 'event', 'Ecommerce', 'click', 'Product click: product list')
}

export const reportProductAddToCartAttempt = (
  item: IItem,
  index: number,
  currentSite: string,
  pageType: string
) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  ga('ec:addProduct', {
    brand: item.author_username,
    category: `${currentSiteDomain}/${item.classification}`,
    id: item.id,
    list: getListName(pageType),
    name: item.name,
    position: index
  })
  ga('ec:setAction', 'add')
  ga('send', 'event', 'Ecommerce', 'click', 'Add to cart: product list')
}

export const reportProductsImpressions = ({
  items,
  currentSite,
  itemRankOffset,
  page,
  section
}: {
  items: IItem[]
  currentSite: string
  itemRankOffset: number
  page: string
  section: string
}) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  items.forEach((item: IItem, index: number) => {
    ga('ec:addImpression', {
      brand: item.author_username,
      category: `${currentSiteDomain}/${item.classification}`,
      id: item.id,
      list: `${page}: ${toTitle(section)}`,
      name: item.name,
      position: index + itemRankOffset
    })
  })
  ga('send', 'event', 'Ecommerce', 'view', 'Product impression', {
    nonInteraction: true
  })
}

export const reportModalPageView = ({
  title,
  page
}: {
  title: string
  page: string
}) => {
  ga('send', {
    hitType: 'pageview',
    page,
    title
  })
}



// WEBPACK FOOTER //
// ./common/analytics/resultAnalytics.tsx